import PropTypes from "prop-types";
import React, {useState} from 'react';
import { MenuItem, Select, TableCell } from '@mui/material';
import { useGetPartnerPlansQuery, useRemovePartnerPlanMutation, useUpdatePartnerPlanMutation } from 'services/user-service';
import toast from 'react-hot-toast';
import ConfirmActionModal from '../partnerUserDetails/ConfirmActionModel'

const PlanSelector = ({ row, setRefetchUser }) => {
    const { data: planNames } = useGetPartnerPlansQuery();
    
    const [updateAssignedPlan] = useUpdatePartnerPlanMutation();
    const [openPlanConfirmModal, setOpenPlanConfirmModal] = useState(false)
    const [currentPlan, setCurrentPlan] = useState(row.plan?.partnerPlanId || '')
    const [confirmAction, setConfirmAction] = useState("remove");
    const [removePlan] = useRemovePartnerPlanMutation()

    const handlePlanChange = async () => {
        try {
            const { message } = await updateAssignedPlan({
                partnerId: row.id,
                planId: currentPlan
            }).unwrap();

            setRefetchUser(true);
            toast.success(confirmAction === 'remove' ? 'Plan Removed' : message || 'Plan Assigned');
        } catch (error) {
            toast.error(`Error updating plan: ${error?.data?.message}`)
        }
    };

    const handleOpenCofirmModal = (event) => {
        const value = event.target.value;
        if (value === 'remove') {
            setConfirmAction('remove');
        } else {
            setConfirmAction('assign');
            setCurrentPlan(value);
        }
        setOpenPlanConfirmModal(true);
    };

    const handleCloseCofirmModal = () => {
        setOpenPlanConfirmModal(false)
        setRefetchUser(true)
    }

    const removePartnerPlan = async () => {

        try {
            const { message } = await removePlan({
                partnerId: row.id,
                planId: currentPlan
            }).unwrap();

            setRefetchUser(true);
            toast.success(confirmAction === 'remove' ? 'Plan Removed' : message || 'Plan Assigned');
        } catch (error) {
            toast.error(`Error updating plan: ${error?.data?.message}`)
        }


    }

    return (
        <TableCell align="center">
            <Select
                value={currentPlan}
                onChange={handleOpenCofirmModal}
                size="small"
                displayEmpty
                sx={{
                    fontSize: '14px',
                    minWidth: '120px',
                    '& .MuiSelect-select': {
                        padding: '6px 10px'
                    }
                }}
            >
                <MenuItem value="" sx={{ fontSize: '14px' }} disabled>
                    Choose Plan
                </MenuItem>
                {planNames?.whitelabelPartnerPlan?.map((plan) => (
                    <MenuItem
                        key={plan._id}
                        value={plan._id}
                        sx={{ fontSize: '14px' }}
                    >
                        {plan.planName}
                    </MenuItem>
                ))}
                <MenuItem
                    value='remove'
                    sx={{ fontSize: '14px', color: 'red' }}
                    disabled={!currentPlan}
                >
                    Remove Plan
                </MenuItem>

            </Select>
            <ConfirmActionModal
                open={openPlanConfirmModal}
                onClose={handleCloseCofirmModal}
                title='Confirmation'
                description={
                    confirmAction === 'remove'
                        ? 'Are you sure you want to Remove this Plan?'
                        : 'Are you sure you want to Update Plan?'
                }
                confirmButtonText='Confirm'
                onConfirm={confirmAction === 'remove' ? removePartnerPlan : handlePlanChange}
            />

        </TableCell>
    );
};

PlanSelector.propTypes = {
    row: PropTypes.shape({
        id: PropTypes.string.isRequired,
        plan: PropTypes.shape({
            customPlanId: PropTypes.string
        })
    }).isRequired,
    setRefetchUser: PropTypes.func.isRequired
};

export default PlanSelector;